<app-nav-red-logo></app-nav-red-logo>

<section class="hero_section d-flex justify-content-center align-items-center">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-5 hero_text mb-5 mb-lg-0">
        <h1 class="hero-title mb-4">WE ARE INSPIRED TO INSPIRE.</h1>
        <div class="brand-text">
          <p class="lead-text mb-4">A culture for the future.</p>
          <p class="hero-description">
            At Zumera, people are at the heart of everything we do. We are a business of the people, for the people and by the people. We believe that every Nigerian has tremendous potential waiting to be unleashed, and given the right environment, they will thrive. Join us and let's make a difference in the world.
          </p>
        </div>
      </div>
      <div class="col-lg-7 hero_img right">
        <img src="assets/imgs/join_our_tribe/hero.gif" alt="Zumera Team" class="img-fluid">
      </div>
    </div>
  </div>
</section>

<section class="dept_section">
  <!-- Loading State -->
  @if (isLoading) {
    <div class="container py-5 text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3">Loading job listings...</p>
    </div>
  }

  <!-- Error State -->
  @if (error && !isLoading) {
    <div class="container py-5 text-center">
      <div class="alert alert-danger" role="alert">
        {{ error }}
      </div>
    </div>
  }

  <!-- Job Listings -->
  @if (!isLoading && !error) {
    @for (job of jobs; track trackByJobId(i, job); let i = $index) {
      <hr>
        <!-- Even index (0, 2, 4...): Image Left, Text Right -->
        @if (i % 2 === 0) {
          <div class="container py-5">
            <div class="row align-items-center dept_container">
              <div class="col-lg-6 dept_img left order-2 order-lg-1">
                <div class="line top-line"></div>
                <div class="line bottom-line"></div>
                <img [src]="'assets/imgs/left-slide.jpeg'"
                  [alt]="job.title"
                  class="img-fluid">
                </div>
                <div class="col-lg-6 dept_text mb-4 mb-lg-0 order-1 order-lg-2 ps-lg-5">
                  <h2 class="dept-title mb-4">{{ job.title }}</h2>
                  <p class="dept-desc mb-4">{{ job.description }}</p>
                  <a [routerLink]="['/join-our-tribe', job.slug]" class="see-positions">
                    See Open Positions <span class="arrow">→</span>
                  </a>
                </div>
              </div>
            </div>
          }
          <!-- Odd index (1, 3, 5...): Text Left, Image Right -->
          @if (i % 2 !== 0) {
            <div class="container py-5">
              <div class="row align-items-center dept_container">
                <div class="col-lg-6 dept_text mb-4 mb-lg-0">
                  <h2 class="dept-title mb-4">{{ job.title }}</h2>
                  <p class="dept-desc mb-4">{{ job.description }}</p>
                  <a [routerLink]="['/join-our-tribe', job.slug]" class="see-positions">
                    See Open Positions <span class="arrow">→</span>
                  </a>
                </div>
                <div class="col-lg-6 dept_img right">
                  <div class="line top-line"></div>
                  <div class="line bottom-line"></div>
                  <img [src]="'assets/imgs/right-slide.jpeg'"
                    [alt]="job.title"
                    class="img-fluid">
                  </div>
                </div>
              </div>
            }
          }
        }
      </section>

      <div class="my-5 d-flex flex-column align-items-center">
        <p class="quote_3_p text-center mb-1">NEXT <span class="arrow-down">↓</span></p>
        <h3 class="footer-next mb-4">NEWS</h3>
        <a routerLink="/news" class="know-more-btn">KNOW MORE</a>
      </div>

      <app-footer class="w-100 d-none d-sm-block"></app-footer>
      <app-footer-sm class="w-100 d-sm-none"></app-footer-sm>
